import { render, staticRenderFns } from "./addSingleThread.vue?vue&type=template&id=1269d2c1&scoped=true"
import script from "./addSingleThread.vue?vue&type=script&lang=js"
export * from "./addSingleThread.vue?vue&type=script&lang=js"
import style0 from "./addSingleThread.vue?vue&type=style&index=0&id=1269d2c1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269d2c1",
  null
  
)

export default component.exports